/* TOPメインビジュアルスライダー */
function mvSlideshow(parameter) {
  // スライド内動画要素の一時停止と再生処理
  function playPauseVideo(slider){
    let slides, video; 
    slides = slider.querySelectorAll(".swiper-slide");
    slides.forEach(function(slide){
      video = slide.querySelector("video");
      if(video) {
        if(slide.classList.contains("swiper-slide-active")) {
          video.play();
        } else {
          video.pause();
        }
      }
    });
  }

  // Swiper定義
  const swiper = new Swiper('.c-top-keyvisual', {
    // Optional parameters
    loop: true,
    speed: 1000,
    lazy: true,
    runCallbacksOnInit: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    // AutoPlay
    //autoplay: {
      //delay: 5000
    //},

    // Event
    on: {
      afterInit: function() {
        playPauseVideo(this.el);
      },
      slideChangeTransitionEnd: function () {
        playPauseVideo(this.el);
      }
    },

    pagination: {
      el: '.c-slideshow__pagination',
      type: "fraction",
      formatFractionCurrent: function(number){
        if(number < 10) {
          return '0' + number
        } else {
          return number;
        }
      },
      formatFractionTotal: function(number){
        if(number < 10) {
          return '0' + number
        } else {
          return number;
        }
      },
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.top-slider-button--next',
      prevEl: '.top-slider-button--prev',
    },
  
  });

  // 関数呼び出しはcustom-loading.js内から行う
  if (parameter === "start") {
    swiper.autoplay.start();
  }

}

/* コラボレーション記事一覧の表示切り替え */
function collaborationViewSwitch() {
  const targetWrapper = document.querySelector('#featuredCollaboration .featured-collaboration__articles');
  if(targetWrapper) {
    const articles = document.querySelectorAll('.featured-collaboration__articles-item'),
          firstArticle = targetWrapper.firstElementChild,
          lastArticle = targetWrapper.lastElementChild;
        
    articles.forEach(function(article){
      let currentArticle = article,
          nextArticle = article.nextElementSibling,
          prevArticle = article.previousElementSibling,
          prevButton = article.querySelector('button[name="previous"]'),
          nextButton = article.querySelector('button[name="next"]');
      
      nextButton.addEventListener('click', function(){
        // 0523 Added アニメーション用中間クラス追加
        currentArticle.classList.add('is-moving');
        setTimeout(function(){
          currentArticle.classList.remove('is-moving');
          currentArticle.classList.add('visually-hidden');
          if(nextArticle === null) {
            firstArticle.classList.remove('visually-hidden');
          } else {
            nextArticle.classList.remove('visually-hidden');
          }
        }, 600)
      });

      prevButton.addEventListener('click', function(){
        // 0523 Added アニメーション用中間クラス追加
        currentArticle.classList.add('is-moving');
        setTimeout(function(){
          currentArticle.classList.remove('is-moving');
          currentArticle.classList.add('visually-hidden');
          if(prevArticle === null) {
            lastArticle.classList.remove('visually-hidden');
          } else {
            prevArticle.classList.remove('visually-hidden');
          }
        }, 600)
      });

    });
  }
}

/* TOPコーディネート記事一覧の位置調整 */
function coordinationMove() {
  const coordinatioElm = document.querySelector('#coordination-container'),
        appendTarget = document.getElementById('topCoordinationWrap'),
        loading = appendTarget.querySelector('.loading-overlay__wrapper');
  if(coordinatioElm && appendTarget) {
    loading.classList.add('hidden');
    appendTarget.appendChild(coordinatioElm);
  }
}

/* コーディネート記事一覧の目次current判定 */
function coordinationObserve() {
  // 変数宣言
  const observeTargets = document.querySelectorAll('.coordination__articles .article'),
        observeRoots = document.querySelectorAll('.top-coordination__navigation .observerTarget');
  
  let i = 0;
  for (const target of observeTargets) {
    let positionY = observeRoots[i].offsetTop,
        windowHeight = window.innerHeight,
        rootMarginA = Math.round((positionY / windowHeight) * 100),
        rootMarginB = 99 - rootMarginA;

    let rootMarginPx = `-${rootMarginA}% 0% -${rootMarginB}%`;
    let options = {
      rootMargin: rootMarginPx,
      threshold: [0]
    };
    observer = new IntersectionObserver(currentItemCheck, options);
    observer.observe(target);
    i += 1;
  }

  function currentItemCheck(entries) {
    entries.forEach(entry => {
      let currentIndex = entry.target.getAttribute("data-index");
      if (entry.intersectionRatio === 0) {
        observeRoots[currentIndex].classList.remove("current");
      } else {
        observeRoots.forEach(element => element.classList.remove("current"));
        observeRoots[currentIndex].classList.add("current");
      }
      
      let currentMinCheck = false;
      for(let element of observeRoots) {
        if(element.classList.contains("current")) {
          currentMinCheck = true;
        }
      }
      if(currentMinCheck === false) {
        observeRoots[0].classList.add("current");
      }

    });
  }

}

/* シリーズ一覧のスライド表示判定 */
function seriesVisibleObserve() {

  // 変数宣言
  let rootMarginPx = "0px 0px 0px 0px",
      rootEl = document.querySelector('.top-series__slider--wrapper .c-slider');
  const options = {
    root: rootEl,
    rootMargin: rootMarginPx,
    threshold: [0, 0.9]
  };
  const observeTarget = document.querySelectorAll('.top-series__slider--wrapper .grid__item'),
        scrollTarget = document.querySelector('.top-series__slider--wrapper .slider'),
        textTabTarget = document.querySelectorAll('.top-series__info-item'),
        observer = new IntersectionObserver(currentSlideCheck, options);
  
  function currentSlideCheck(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio <= 0.9) {
        entry.target.classList.remove("current");
      } else {
        entry.target.classList.add("current");
        textTabSwitch();
      }
    });
    observer.disconnect();
  }

  // スライド表示に連動したテキストの表示切り替え
  function textTabSwitch() {
    let i = 0;
    textTabTarget.forEach(target => {
      target.classList.add('visually-hidden')
    });
    for (const slide of observeTarget) {
      if(slide.classList.contains("current")) {
        textTabTarget[i].classList.remove('visually-hidden')
      }
      i += 1;
    }
  }

  //スライダー内でのスクロール発生時のみ発火させる
  scrollTarget.addEventListener('scroll', function(){
    observeTarget.forEach(entry => {
      observer.observe(entry);
    })
  });

  //スライドUIボタン押下時のフォールバック
  document.querySelector('.top-series__slider--wrapper .c-slider-nav__buttons').addEventListener('click', function(){
    observeTarget.forEach(entry => {
      observer.observe(entry);
    })
  });
  
}

/* コレクション商品一覧のタブ切り替え表示 */
function rankingTabs() {
  const btnArray = document.querySelectorAll('.collection-tabs__switcher-btn');
  let width = 0;

  function tabSwitch(item, index){
    const parentWrapper = item.closest('.collection-tabs__wrapper'),
          switcher = parentWrapper.querySelector('.collection-tabs__switcher'),
          tabContents = parentWrapper.querySelectorAll('.collection-tabs__content');
    
    switcher.querySelectorAll('.is-active')[0].classList.remove('is-active');
    parentWrapper.querySelectorAll('.is-show')[0].classList.remove('is-show');
    item.classList.add('is-active');
    tabContents[index].classList.add('is-show');
  }

  if(btnArray) {
    btnArray.forEach( function(btn, index) {
      btn.addEventListener('click',function(){
        tabSwitch(btn, index);
        // custom-component-slider.js内の関数呼び出し
        customSliderScrollbar();
      });
    })
  }

}

/* NIKKO StyleのMasonryレイアウト */
function customMasonry() {
  const targetWrapper = document.querySelector('#top-nikko-style .c-masonry--active');
  if(targetWrapper) {
    const baseHeightArray = [
      document.querySelector('#nikko-style__article-1 a'),
      document.querySelector('#nikko-style__article-2 a'),
      document.querySelector('#nikko-style__article-3 a')
    ]
    const targetArray = [
      document.querySelector('#nikko-style__article-4'),
      document.querySelector('#nikko-style__article-5'),
      document.querySelector('#nikko-style__article-6')
    ]
    let loading = document.querySelector('#top-nikko-style .loading-overlay__wrapper');

    function masonryPositionSet() {
      let i = 0;
      for (const el of targetArray) {
        if(window.innerWidth <= 749) {
          el.style.paddingTop = '0px';
        } else {
          let paddingHeight = baseHeightArray[i].clientHeight;
          el.style.paddingTop = paddingHeight + 64 + 'px';
          i += 1;
        }
      }
    }
    masonryPositionSet();
    loading.classList.add('hidden');
    targetWrapper.classList.remove('c-masonry--loading');

    // 画面リサイズ時の再実行
    const resizeObserver = new ResizeObserver(entries => {
      masonryPositionSet();
    });
    
    resizeObserver.observe(targetWrapper);
  }
}

/* TOPページのDawnスライドコンポーネントにドラッグ操作を付与する（スワイプは標準対応） */
function customSliderMove() {
  // 操作対象スライダー
  const customSlider = document.querySelectorAll('.c-slider-scrollbar__active .c-slider'),
        collaboSlider = document.querySelectorAll('.featured-collaboration__articles');
  let
    dragStartX, //ドラッグ始点のx座標
    dragEndX, //ドラッグ終点のx座標
    dragDistanceX, //x軸方向のドラッグ距離
    hrefUrl,
    hasClicked;
    hasClicked = false;
  
  if(customSlider) {
    dragListener(customSlider, 'slider');
  }
  if(collaboSlider) {
    // Collaborationスライダーのみ構造が異なるため別途指定
    dragListener(collaboSlider, 'switch');
    touchListener(collaboSlider);
  }

  // Collaborationスライダーのみスワイプ操作に別途対応
  function touchListener(target) {
    let direction, position;
    function getPosition(event) {
      return event.changedTouches[0].pageX;
    }

    target.forEach(function(el){
      el.addEventListener("touchstart", function(event){
        position = getPosition(event);
        direction = ""; //一度リセットする
      });
      el.addEventListener("touchmove", function (event) {
        if (position - getPosition(event) > 70) {
          direction = "left"; //左と検知
        } else if (position - getPosition(event) < -70) {
          direction = "right"; //右と検知
        }  
      });
      el.addEventListener("touchend", function(event){
        let prevBtn = event.target.closest('.featured-collaboration__articles-item').querySelector('.c-button[name="previous"]'),
        nextbtn =  event.target.closest('.featured-collaboration__articles-item').querySelector('.c-button[name="next"]');
        if (direction == "right") {
          prevBtn.click();        
        } else if (direction == "left") {
          nextbtn.click();
        }
      });
    })
  }

  function dragListener(target, view) {
    target.forEach(function(slider){
      // 標準のドラッグ＆リンク遷移イベントを解除
      slider.querySelectorAll('img').forEach(function(el){
        el.setAttribute('draggable', false);
      })
      slider.querySelectorAll('a').forEach(function(el){
        el.setAttribute('draggable', false);
        el.addEventListener('click', function(event) {
          event.preventDefault(); //通常のリンク遷移はキャンセル
        });
        // 遷移先URLを取得（クリック判定時に利用
        el.addEventListener('mousedown', function(event) {
          hrefUrl = el.href;
        });
      });

      // スライダー内のドラッグ判定
      slider.addEventListener("mousedown", function (event) {
        dragStartX = event.clientX; //始点のx座標を取得
        hasClicked = true;
      });
      slider.addEventListener("mouseleave", function (event) {
        if(hasClicked === true) {
          dragEndX = event.clientX; //終点のx座標を取得
          if(view == 'slider') {
            getDirection(slider, view);
          } else {
            getDirection(event.target, view);
          }
        }
        hasClicked = false;
      });
      slider.addEventListener("mouseup", function (event) {
        dragEndX = event.clientX; //終点のx座標を取得
        hasClicked = false;
        if(view == 'slider') {
          getDirection(slider, view);
        } else {
          getDirection(event.target, view);
        }
      });
    })
  }

  function getDirection(el, view) {
    dragDistanceX = dragEndX - dragStartX;//(終点x座標) - (始点x座標) → 移動距離(x軸方向)を取得

    let prevBtn, nextbtn;

    // 標準スライダーコンポーネントとCollaborationスライダーの条件分岐
    if(view == 'slider') {
      prevBtn = el.closest('slider-component').querySelector('.c-button[name="previous"]'),
      nextbtn = el.closest('slider-component').querySelector('.c-button[name="next"]');
    } else if(view == 'switch') {
      prevBtn = el.closest('.featured-collaboration__articles-item').querySelector('.c-button[name="previous"]'),
      nextbtn = el.closest('.featured-collaboration__articles-item').querySelector('.c-button[name="next"]');
    }
    
    //移動距離が正なら軸プラス方向、負なら軸マイナス方向への移動と判断
    if (dragDistanceX !== undefined && dragDistanceX > 0) {
      prevBtn.click();
    } else if (dragDistanceX !== undefined && dragDistanceX < 0) {
      nextbtn.click();
    } else {
      // クリックと判定した場合はリンク遷移
      if(hrefUrl !== undefined) {
        window.location.href = hrefUrl;
      }
    }
  }
}


/* 関数実行 */
coordinationMove();
collaborationViewSwitch();
rankingTabs();

// observe検証・サイズ調整系は画像などload完了後に実行
window.addEventListener('load',function(){
  coordinationObserve();
  seriesVisibleObserve();
  customSliderMove();
  customMasonry();
});